// @ts-nocheck
import React from 'react';
import { captureClientSideError } from '@scale/frontend-lib/errors';

export function displayErrorMessage(err, taskId?: string, customMessage?: string) {
  let errorMessage = err.message || err.error || 'Error';
  let errorId;

  if (err.response) {
    errorMessage = customMessage || errorMessage;
    if (err.response.error) {
      errorMessage += `: ${err.response.error}`;
    }

    errorId = err.response.errorId;
  } else if (err.failedToFetch) {
    errorMessage = `It appears that you're offline. Please check your internet connection and try again. Error details: ${errorMessage}`;
  } else {
    errorMessage = `Something went wrong. Error details: ${errorMessage}`;
    captureClientSideError(err, errorMessage);
  }

  if (err.status >= 500) {
    errorMessage += ` - Please try again later. If that doesn't work, please contact support.`;
  }

  const copyToClipboard = text => {
    return () => {
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    };
  };

  const metadata = { taskId, errorId };
  const filteredMetadata = Object.keys(metadata).filter(key => metadata[key]);

  return (
    <span>
      {errorMessage}
      {filteredMetadata ? (
        <span>
          <br />
          {filteredMetadata.map(key => {
            return (
              <React.Fragment key={key}>
                <br />
                <span>
                  {key} (
                  <span className="copy" onClick={copyToClipboard(metadata[key])}>
                    copy
                  </span>
                  ): {metadata[key]}
                </span>
              </React.Fragment>
            );
          })}
        </span>
      ) : null}
      <br />
      <br />(
      <span
        className="copy"
        onClick={copyToClipboard(
          errorMessage +
            '\n\n' +
            filteredMetadata.map(key => `${key}: ${metadata[key]}`).join(', \n'),
        )}
      >
        copy full error
      </span>
      )
      <style jsx>{`
        .copy {
          text-decoration: underline;
          cursor: pointer;
        }

        .copy:hover {
          background: var(--bg-gray-light);
        }
      `}</style>
    </span>
  );
}

export async function tryParseErrorResponse(response) {
  try {
    // If response is a JSON, parse it. If it does not include a status, put the response's status.
    const errorObj = typeof response === 'string' ? JSON.parse(response) : await response.json();
    if (!errorObj.status) {
      errorObj.status = response.status;
    }

    if (!errorObj.message) {
      errorObj.message = errorObj.error;
    }

    return errorObj;
  } catch (err) {
    // If we cannot parse the json, just return an object with the status
    return {
      status: response.status,
      message: 'An error has occurred',
    };
  }
}
